import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#a)",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.589 3.03C10.373 4.073 9.5 5.73 9.5 8.2V13c0 2.917 1.605 5.443 3.338 7.031A.5.5 0 0 1 13 20.4V22c0 .69-.354 1.48-1.33 2.192-.962.7-2.546 1.344-5.081 1.8l-.006.001A6.2 6.2 0 0 0 1.62 30.5h28.687a7.25 7.25 0 0 0-5.4-4.509c-2.532-.48-4.007-1.126-4.854-1.84C19.168 23.406 19 22.616 19 22v-1.6a.5.5 0 0 1 .162-.369C20.894 18.444 22.5 15.87 22.5 13V8.2c0-2.47-.873-4.126-2.088-5.17C19.182 1.972 17.557 1.5 16 1.5s-3.183.473-4.411 1.53m-.652-.76C12.383 1.028 14.257.5 16 .5c1.744 0 3.617.527 5.064 1.77C22.523 3.527 23.5 5.47 23.5 8.2V13c0 3.138-1.691 5.892-3.5 7.617V22c0 .384.082.869.697 1.386.653.55 1.927 1.154 4.396 1.623h.001a8.25 8.25 0 0 1 6.387 5.855.5.5 0 0 1-.481.636H1a.5.5 0 0 1-.493-.583 7.2 7.2 0 0 1 5.907-5.91c2.463-.443 3.879-1.05 4.667-1.624C11.854 22.82 12 22.31 12 22v-1.383c-1.807-1.721-3.5-4.43-3.5-7.617V8.2c0-2.73.977-4.674 2.437-5.93",
			clipRule: "evenodd"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M0 0h32v32H0z"
		})
	}) })]
});
export default SvgIconUser;
